import { getBusinessRules } from '../countries/businessRules'

import type {
  CountryBrandRulesProfile,
  QueryCountryCode,
} from '@ngb-frontend/shared/types'

/**
 * The country's brand / channel rules (theme, Sitecore brand, phone, autopick),
 * from the country registry. Call sites branch on the resolved values, never on
 * country identifiers.
 */
export const resolveBrandRules = (
  countryCode?: QueryCountryCode,
): CountryBrandRulesProfile => getBusinessRules(countryCode).brand
